var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-wrap"},[_c('VCarousel'),_c('div',{staticClass:"pay-inner"},[_c('h2',[_vm._v("A产品增值服务购买")]),_c('h3',[_vm._v("Purchase of value-added services")]),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }